import React from 'react';

const EmptyListCard = ({ 
  svgsrc,
  title='',
  subTitle = '',
  classes='',
  svgClasses='h-32',
  titleClasses = '',
  subTitleClasses=''
}) => {

  return (
    <div className={`flex w-full flex-col justify-center items-center ${classes}`}>
      <img src={svgsrc} alt='no-item-image' className={` ${svgClasses}`} />
      <div className={`font-semibold text-base text-gray-800 mt-4 ${titleClasses}`}>
        {title}
      </div>
      <div className={`text-center text-sm text-gray-500 mt-2 ${subTitleClasses}`}>
        {subTitle}
      </div>
    </div>
  );
};

export default EmptyListCard;